import { render, staticRenderFns } from "./MessageImage.vue?vue&type=template&id=352ffe14&scoped=true&"
import script from "./MessageImage.vue?vue&type=script&lang=js&"
export * from "./MessageImage.vue?vue&type=script&lang=js&"
import style0 from "./MessageImage.vue?vue&type=style&index=0&id=352ffe14&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352ffe14",
  null
  
)

export default component.exports